// GLOBAL VARIABLE SETUP
// =================================================================================================
// COMPONENTS
import React from 'react';

import '../../styles/modal.css'

import feather from 'feather-icons';


// MAIN REACT CLASS DECLARATION
// =================================================================================================
class Confirm extends React.Component {


	// REACT APP CONSTRUCTOR
	// =============================================================================================
	constructor( props ) {

		super( props );

		this.state = {};
	}


	// MAIN RENDER METHOD
	// =============================================================================================
	render() {
		
		return <div className="modal__shade">
			<div className="modal__shade__container__gradient">
				<div className="options__container">

					<h3>{ this.props.dialogue }</h3>

					<div className="btn-group btn-group_even">

						<button className="btn" onClick={ ( e ) => this.closeModal( e ) }>Cancel</button>

						{ typeof this.props.confirm === 'object' && typeof this.props.confirm.$$typeof !== 'undefined' ?

							// IF WHAT WE WERE PASSED AS A CONFIRM PROP HAS A TYPEOF KEY › ASSUME A REACT ELEMENT AND RENDER IT
							this.props.confirm

						:

							// ELSE › JUST RENDER A BUTTON WITH CONFIRM AS A CALLBACK
							<button className="btn btn_blue" onClick={ ( e ) => this.confirm( e ) }>Ok</button>
						}
					</div>
				</div>
			</div>
		</div>;
	}


	confirm() {

		// CALL CONFIRM CALLBACK
		this.props.confirm();

		// UNSET STATE
		this.props.Editor.setState( prevState => ({
			confirm: false,
			confirmDialogue: false
		}) );
	}


	// =============================================================================================
	closeModal() {

		this.props.Editor.setState( prevState => ({
			confirm: false,
			confirmDialogue: false
		}) );
	}
}

export default Confirm;


// WEBPACK FOOTER //
// ./src/scenes/Editor/confirm.js